import { render, staticRenderFns } from "./TheResponsiveSidebar.vue?vue&type=template&id=9bcc5e86&scoped=true"
import script from "./TheResponsiveSidebar.vue?vue&type=script&lang=js"
export * from "./TheResponsiveSidebar.vue?vue&type=script&lang=js"
import style0 from "./TheResponsiveSidebar.vue?vue&type=style&index=0&id=9bcc5e86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bcc5e86",
  null
  
)

export default component.exports